import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from './auth/auth.service';
import { Subscription } from 'rxjs/Subscription';

import { cancelSubscription } from './shared/cancelSubscription';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  isLogin: boolean;
  messages = Array();
  materialTheme: string;
  private subscription1: Subscription;
  constructor(private router: Router,
              private location: Location,
              private auth:  AuthService) { }

  ngOnInit() {

    this.subscription1 = this.router.events
        .subscribe((d) => {
        this.isLogin = this.location.path() === '/login' || this.location.path() === '/reset-password' 
        || this.location.path() === '/new-password';
    });
  }

  ngOnDestroy() {
    cancelSubscription([this.subscription1]);
  }

}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/app.component.ts